<mat-expansion-panel [expanded]="IsSectionExpanded" class="policy-holder-component">
    <mat-expansion-panel-header *ngIf="PolicyHolders.length > 1">
        <mat-panel-title>
            <span><b>Carrier:</b>  {{PolicyHolderNameOfTheCarrier.value}}</span>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div [id]="'ph-form'+ Index" [formGroup]="Form" class="form-section mt-20">
        <div [id]="'ph-form-section-1-'+ Index" class="form-section">
            <div [id]="'ph-form-section-1-question-1-'+ Index" class="label-question mb-10">
                Who is the policy holder?
            </div>
            <div [id]="'ph-form-section-1-ro-1-'+ Index" class="inline-item mb-10 form-radio-group">
                <mat-radio-group required formControlName="PolicyHolderType" class="">
                    <mat-radio-button [id]="'ph-option-self-' + Index" value="IsSelf">Self</mat-radio-button>
                    <mat-radio-button [id]="'ph-option-spouse-' + Index" value="IsSpouse">Spouse</mat-radio-button>
                    <mat-radio-button [id]="'ph-option-dependent-' + Index" value="IsDependent">Dependent</mat-radio-button>
                    <mat-radio-button [id]="'ph-option-other-' + Index" value="IsOther">Other (Relationship:)</mat-radio-button>
                </mat-radio-group>
                <enterprise-text-input  [InputId]="'ph-input-type-other-'+ Index"
                                        [InputName]="'PolicyHolderOther-'+ Index"
                                        Label=""
                                        [ErrorMessageOverride]="SetErrorTooltipMessage('PolicyHolderOther', 'Other')"
                                        *ngIf="ShowPolicyHolderTypeOther"
                                        formControlName="PolicyHolderOther"
                                        class="input-fill policy-holder-other-input"
                                        [MaxLength]="PolicyHolderTypeOtherMaxLength"
                                        [Appearance]="'fill'">
                </enterprise-text-input>
            </div>
        </div>
        <div [id]="'ph-form-section-2-'+ Index" class="inline-item mb-10">
            <enterprise-text-input  [InputId]="'ph-input-policy-holder-name-'+ Index"
                                    [InputName]="'PolicyHolderName-'+ Index"
                                    Label="Name"
                                    [ErrorMessageOverride]="SetErrorTooltipMessage('PolicyHolderName', 'Name')"
                                    formControlName="PolicyHolderName"
                                    class="inline-form-input"
                                    [MaxLength]="PolicyHolderNameMaxLength"
                                    [Appearance]="'outline'">
            </enterprise-text-input>
            <enterprise-date-input  [id]="'ph-date-dob-'+ Index"
                                    Label="Date of Birth"
                                    formControlName="PolicyHolderDateOfBirth"
                                    class="inline-form-input"
                                    [Appearance]="'outline'"
                                    [InputId]="'ph-date-dob-'+ Index"
                                    [InputName]="'PolicyHolderDateOfBirth-'+ Index">
            </enterprise-date-input>
            <enterprise-text-input  [InputId]="'ph-input-phidentification-'+ Index"
                                    [InputName]="'PolicyHolderIdentification-'+ Index"
                                    [ErrorMessageOverride]="SetErrorTooltipMessage('PolicyHolderIdentification', 'ID')"
                                    Label="ID"
                                    formControlName="PolicyHolderIdentification"
                                    class="inline-form-input"
                                    [MaxLength]="PolicyHolderIdentificationMaxLength"
                                    [Appearance]="'outline'">
            </enterprise-text-input>
            <enterprise-text-input  [InputId]="'ph-input-phnamecarrier-'+ Index"
                                    [InputName]="'PolicyHolderNameOfTheCarrier-'+ Index"
                                    [ErrorMessageOverride]="SetErrorTooltipMessage('PolicyHolderNameOfTheCarrier', 'Name of Other Carrier')"
                                    Label="Name of Other Carrier"
                                    formControlName="PolicyHolderNameOfTheCarrier"
                                    class="inline-form-input"
                                    [MaxLength]="PolicyHolderNameOfTheCarrierMaxLength"
                                    [Appearance]="'outline'">
            </enterprise-text-input>
            <app-input-phone [id]="'ph-phone-customer-service-'+ Index"
                             [Label]="'Carrier Customer Service #'"
                             [Form]="Form"
                             [FormControlName]="'PolicyCarrierCustomerService'"
                             [ButtonDisabled]="true"
                             [ShowButton]="true"
                             [InputId]="'ph-phone-customer-service-'+ Index"
                             [InputName]="'PolicyCarrierCustomerService-'+ Index">
            </app-input-phone>
        </div>
        <div [id]="'ph-form-section-3-'+ Index" class="form-section inline-item mb-10">
            <div class="label-question mb-10">
                Are there other members of the policy?
            </div>
            <machinify-enterprise-yes-no  [id]="'ph-yes-no-hasopm-'+ Index"
                                formControlName="HasOtherPolicyMembers"
                                class="question-answer-input"
                                [Hidden]="false"
                                [HideIfDisabled]="false"
                                [InputId]="'ph-yes-no-hasopm-'+ Index"
                                [InputName]="'HasOtherPolicyMembers-'+ Index">
            </machinify-enterprise-yes-no>
        </div>
        <div [id]="'ph-form-section-4-'+ Index" class="form-section member-section" *ngIf="ShowHasOtherPolicyMembers">
            <label class="label-question-light br-1">
                <i>Please add all the other members of the policy below:</i>
            </label>
            <div [id]="'ph-form-section-4-pm-'+ Index"  formArrayName="PolicyMembers">
                <app-policy-holder-member *ngFor="let policyMemberForm of PolicyMembers.controls; let indexMember=index" [id]="'ph-'+Index+'pm-'+indexMember"
                                            [Form]="policyMemberForm"
                                            [Index]="indexMember"
                                            [PolicyHolderIndex]="Index"
                                            [PolicyMembers]="PolicyMembers">
                </app-policy-holder-member>
            </div>
        </div>
        <div [id]="'ph-form-action-'+ Index" class="button-footer-section" *ngIf="ShowDeletePolicyButton">
            <button [id]="'ph-form-action-delete'+ Index"
                    (click)="DeletePolicyHolder()"
                    mat-icon-button
                    color="warn"
                    type="button">
                    <mat-icon>delete</mat-icon>
            </button>
        </div>
</div>

</mat-expansion-panel>

